import {combineReducers} from '@modifi/redux'

import allRatesReducer from './allRates'

export default combineReducers({
  allRates: allRatesReducer,
})
